import { formatPrismicData } from '@monofront/business/utils';
import { BrandsLogoListProps, IBrandsLogoList } from './types';

export const mapBrandslogoList = ({
  prismicContent,
}: {
  prismicContent: BrandsLogoListProps;
}): IBrandsLogoList => {
  const { primary, items }: IBrandsLogoList = formatPrismicData(
    prismicContent,
    ['collection'],
  );

  return {
    primary,
    items,
  };
};
